import { polkaFantasy } from 'pools/finished/polkafantasy/polkaFantasy';
import { polkafantasyLand } from 'pools/finished/polkafantasy/polkafantasy-land';

export const polkaFantasyPools = [polkaFantasy, polkafantasyLand];
